import { useEffect, useState } from "react";

type DataAttributes = {
  [K in `data-${string}`]: string | undefined;
};
type Options = Pick<
  HTMLScriptElement,
  | "async"
  | "crossOrigin"
  | "defer"
  | "integrity"
  | "noModule"
  | "referrerPolicy"
  | "type"
>;

export function useScript(
  src: string,
  options?: Partial<Options>,
  data?: DataAttributes,
): boolean {
  const [loaded, setLoaded] = useState(
    document.head.querySelector(`script[src="${src}"]`) !== null,
  );

  useEffect(() => {
    const loaded = document.head.querySelector(`script[src="${src}"]`) !== null;

    if (!loaded) {
      const script = document.createElement("script");
      const controller = new AbortController();

      if (options !== undefined) {
        Object.assign(script, options);
      }

      if (data !== undefined) {
        for (const [key, value] of Object.entries(data)) {
          if (value !== undefined) {
            script.setAttribute(key, value);
          }
        }
      }

      script.addEventListener("load", () => setLoaded(true), {
        signal: controller.signal,
      });
      script.src = src;
      document.head.appendChild(script);

      return () => {
        controller.abort();
        document.head.removeChild(script);
      };
    }
  }, [data, options, src]);

  return loaded;
}
